import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { CheckoutDto } from '@dto/checkoutDto';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentsService } from '@services/payments/payments.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.scss']
})
export class UpgradeComponent extends ComponentBase implements OnInit {

  public className = 'UpgradeComponent';

  public price: string = '36,00';
  @Input() numberOfChargingStations: number = 2;
  @Input() numberOfUsers: number = 2;
  @Input() numberOfCards: number = 2;
  
  public features = [
    {
      name: 'Verwaltung',
      description: 'Über Verwaltungsfunktionen können Sie Benutzer anlegen, Ladestationen zuweisen und RFID-Karten autorisieren.',
      abonnements: 'standard, premium, enterprise'
    },
    {
      name: 'Suchen und Filtern',
      description: 'Filtern Sie für einen besseren Überblick die Anzeige der Ladestatistik nach Tag, Monat oder Jahr.',
      abonnements: 'standard, premium, enterprise'
    },
    {
      name: 'Grafische Auswertung',
      description: 'Möglichkeit einer detaillierten Auswertung des Ladegeschehens nach Benutzern, Ladestationen, Gruppen und individuellen Filterangaben.',
      abonnements: 'standard, premium, enterprise'
    },
    {
      name: 'FreeCharge-Modus',
      description: 'Die Möglichkeit, eine Ladestation für alle auch ohne RFID-Karte permanent zugänglich zu machen.',
      abonnements: 'standard, premium, enterprise'
    },
    {
      name: 'Fernsteuern',
      description: 'Die Möglichkeit, den Ladevorgang für nicht autorisierte Benutzer dennoch zu gestatten.',
      abonnements: 'premium, enterprise'
    },
    {
      name: 'Rechnungen und Lieferscheine',
      description: 'Die Möglichkeit, individuelle Verbräuche von Benutzern, Ladestationen und Gruppen als PDF zu exportieren und so zum Beispiel für Abrechnungen zu dokumentieren.',
      abonnements: 'premium, enterprise'
    },
    {
      name: 'Gruppieren',
      description: 'Gruppieren Sie Benutzer und Ladestationen nach Ihren Bedürfnissen.',
      abonnements: 'enterprise'
    },
    {
      name: 'Ladestationen',
      description: 'Anzahl der verwaltenbaren Ladestationen.',
      abonnements: 'standard, premium, enterprise',
      standard: '1',
      premium: '2',
      enterprise: 'ab 3'
    },
    {
      name: 'RFID-Karten',
      description: 'Anzahl der anzulernenen RFID-Karten.',
      abonnements: 'standard, premium, enterprise',
      standard: '2',
      premium: '4',
      enterprise: 'ab 5'
    },
    {
      name: 'Benutzer',
      description: 'Anzahl der anzulegenden Benutzer.',
      abonnements: 'standard, premium, enterprise',
      standard: '2',
      premium: '4',
      enterprise: 'ab 5'
    },
  ]

  constructor(
    private paymentsService: PaymentsService,
    private dialog: NgbModal,
    private viewportScroller: ViewportScroller,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    
  }

  subscribeTo(product) {
    const checkout = new CheckoutDto()
    checkout.priceId = product
    checkout.userId = localStorage.getItem('userId')

    this.paymentsService.createCheckoutSessionForCUBOSConnect(checkout).subscribe(result => {
      window.location.href = result.checkoutUrl;
    }, error => {console.error(error)});
  }
  
  scrollToAnchor(anchor) {
    this.viewportScroller.scrollToAnchor(anchor);
  }

  updateNumberOfChargingStations(value) {
    this.numberOfChargingStations = value
    this.updatePrice()
  }
  updateNumberOfUsers(value) {
    this.numberOfUsers = value
    this.updatePrice()
  }
  updateNumberOfCards(value) {
    this.numberOfCards = value
    this.updatePrice()
  }

  updatePrice() {
    this.price = Math.abs(
      (3600 
        + (this.numberOfChargingStations > 2 ? (this.numberOfChargingStations - 2) * 73 : 0)
        + (this.numberOfUsers > 2 ? (this.numberOfUsers - 2) * 32 : 0)
        + (this.numberOfCards > 2 ? (this.numberOfCards - 2) * 21 : 0)
      ) / 100).toFixed(2).toString()
  }
  
}
